// extracted by mini-css-extract-plugin
module.exports = {"SHotlink":"Hotlinks_SHotlink__KcUwX","easter":"Hotlinks_easter__SIQvA"};